import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { KeyValue } from '@carm/_core';
import { takeUntil } from 'rxjs/operators';
import { BaseInputComponent } from '../../base/base-input/base-input.component';
import { SelectOption } from '../../data/select-options';

@Component({
  selector: 'carm-select-field',
  templateUrl: './select-field.component.html',
  styleUrls: ['./select-field.component.scss'],
})
export class SelectFieldComponent extends BaseInputComponent implements OnInit, OnChanges {
  @Input() inDisabled = false;
  @Input() inOptionClass: string;
  @Input() inOptionMsg: string;
  // This array object will be moved to another location dedicated for static data
  @Input() inOptions: SelectOption[];
  @Input() inValueClass: boolean;
  @Input() fitToSize = false;
  @Input() autoSort = true;
  @Input() persistToUrl = false;
  @Output() optionChange = new EventEmitter<any>();

  isEdge = false;
  compareFn = this._compareFn.bind(this);
  oneItem = '';

  constructor(private router: Router, private activatedRoute: ActivatedRoute) {
    super();
  }

  onItemChange($event: any) {
    this.optionChange.emit($event);
  }

  ngOnChanges(changes: SimpleChanges) {
    this.oneType()

    if (changes?.inOptions?.currentValue && changes?.inOptions?.currentValue?.length > 0) {

      this.inOptions = [...this.inOptions];

      if (this.autoSort) {
        this.inOptions.sort((a: SelectOption, b: SelectOption) => new Intl.Collator('fr').compare(a.value, b.value));
      }
      const enIndex = this.inOptions?.findIndex((item: SelectOption) => {
        return item?.value?.toLowerCase() === "other";
      })
      const frIndex = this.inOptions?.findIndex((item: SelectOption) => {
        return item?.value?.toLowerCase() === "autre";
      })
      let other;
      if (enIndex !== -1) {
        other = this.inOptions[enIndex];
        this.inOptions = this.inOptions?.filter(item => item?.value?.toLowerCase() !== "other");
        this.inOptions?.push(other);
      }
      if (frIndex !== -1) {
        other = this.inOptions[frIndex];
        this.inOptions = this.inOptions?.filter(item => item?.value?.toLowerCase() !== "autre");
        this.inOptions?.push(other);
      }

      if(this.persistToUrl && this.inId){
        this.trySetValueFromUrl(this.inId)
      }
    }
  }

  ngOnInit() {
    super.ngOnInit();
    this.detectEdge();
    this.oneType();   
    this.formControl.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(v => {
      if(this.persistToUrl && this.controlName){
        this.persistDataInUrl(this.controlName, this.formControl.value);
      }
    })
  }

  /** If the field is required and there's only 1 type in a category the type will be auto selected **/
  oneType(){
    if(this.isRequired){
      if (null !== this.inOptions ) {
        if (undefined !== this.inOptions && this.inOptions.length) {
          if (this.inOptions.length === 1 && !!this.formControl) {
            const selectedOption = this.inOptions[0].key;
            this.oneItem = selectedOption;
            this.formControl.setValue(selectedOption);
          }
        }
      }
    }
  }

  detectEdge() {
    const browser = ((agent) => {
      switch (true) {
        case agent.indexOf('edge') > -1: return 'edge';
        case agent.indexOf('edg/') > -1: return 'chromium based edge (dev or canary)'; // Match also / to avoid matching for the older Edge
        default: return 'other';
      }
    })(window.navigator.userAgent.toLowerCase());

    if (browser === 'chromium based edge (dev or canary)' || browser === 'edge') {
      this.isEdge = true;
    }
  }

  _compareFn(a: KeyValue, b: KeyValue) {
    // Handle compare logic (eg check if unique ids are the same)
    return a?.key === b?.key;
  }

  trackByFn(index: number, item: any) {
    return item.key; // Prevent unnecessary re-renders
  }

  private persistDataInUrl(controlName: string, selectedValue: string) : Promise<boolean> {

    let queryParams = {};
    if(selectedValue){
      queryParams[controlName] = selectedValue;
    }else{
      queryParams[controlName] = null;
    }

    return this.router.navigate([], {
      queryParams: queryParams,
      queryParamsHandling: 'merge',
      fragment: this.inId,
      replaceUrl: true
    });
  }

  private trySetValueFromUrl(controlName: string) {

    const urlValue = this.activatedRoute.snapshot.queryParams[controlName];

    if(urlValue){
      this.group.controls[controlName].setValue(urlValue, { emitEvent: true});
    }
  }
}
